/**
 * Calculate pagination metadata
 *
 * @author Mantu Kumar
 * @created 06-Feb-2026
 * @email developer.mantu@gmail.com
 *
 * @param {Object} pagination - Pagination object from API
 * @param {number} currentPage - Current active page
 * @returns {Object} Pagination meta information
 */
export const getPaginationMeta = (pagination = {}, currentPage = 1) => {
    const total = Number(pagination.total ?? 0);
    const limit = Number(pagination.limit ?? 40);

    const totalPages = total > 0
        ? Math.ceil(total / limit)
        : 1;

    const safeCurrentPage = Math.min(
        Math.max(Number(currentPage) || 1, 1),
        totalPages
    );

    const rangeStart =
        total === 0 ? 0 : (safeCurrentPage - 1) * limit + 1;

    const rangeEnd =
        total === 0 ? 0 : Math.min(safeCurrentPage * limit, total);

    return {
        total,
        limit,
        totalPages,
        currentPage: safeCurrentPage,
        rangeStart,
        rangeEnd,
        hasNextPage: safeCurrentPage < totalPages,
        hasPrevPage: safeCurrentPage > 1,
    };
};
